var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-about-app content"},[_c('h1',{staticClass:"page__title"},[_vm._v(_vm._s(_vm.str('aboutApp.menuTitle')))]),_c('About')],1)}
var staticRenderFns = []

export { render, staticRenderFns }